/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */
/*! Image Map Resizer (imageMapResizer.min.js ) - v1.0.10 - 2019-04-10
 *  Desc: Resize HTML imageMap to scaled image.
 *  Copyright: (c) 2019 David J. Bradshaw - dave@bradshaw.net
 *  License: MIT
 */

!function(){"use strict";function r(){function e(){var r={width:u.width/u.naturalWidth,height:u.height/u.naturalHeight},a={width:parseInt(window.getComputedStyle(u,null).getPropertyValue("padding-left"),10),height:parseInt(window.getComputedStyle(u,null).getPropertyValue("padding-top"),10)};i.forEach(function(e,t){var n=0;o[t].coords=e.split(",").map(function(e){var t=1==(n=1-n)?"width":"height";return a[t]+Math.floor(Number(e)*r[t])}).join(",")})}function t(e){return e.coords.replace(/ *, */g,",").replace(/ +/g,",")}function n(){clearTimeout(d),d=setTimeout(e,250)}function r(e){return document.querySelector('img[usemap="'+e+'"]')}var a=this,o=null,i=null,u=null,d=null;"function"!=typeof a._resize?(o=a.getElementsByTagName("area"),i=Array.prototype.map.call(o,t),u=r("#"+a.name)||r(a.name),a._resize=e,u.addEventListener("load",e,!1),window.addEventListener("focus",e,!1),window.addEventListener("resize",n,!1),window.addEventListener("readystatechange",e,!1),document.addEventListener("fullscreenchange",e,!1),u.width===u.naturalWidth&&u.height===u.naturalHeight||e()):a._resize()}function e(){function t(e){e&&(!function(e){if(!e.tagName)throw new TypeError("Object is not a valid DOM element");if("MAP"!==e.tagName.toUpperCase())throw new TypeError("Expected <MAP> tag, found <"+e.tagName+">.")}(e),r.call(e),n.push(e))}var n;return function(e){switch(n=[],typeof e){case"undefined":case"string":Array.prototype.forEach.call(document.querySelectorAll(e||"map"),t);break;case"object":t(e);break;default:throw new TypeError("Unexpected data type ("+typeof e+").")}return n}}"function"==typeof define&&define.amd?define([],e):"object"==typeof module&&"object"==typeof module.exports?module.exports=e():window.imageMapResize=e(),"jQuery"in window&&(window.jQuery.fn.imageMapResize=function(){return this.filter("map").each(r).end()})}();
//# sourceMappingURL=imageMapResizer.map
(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        
        // Init Tooltips
        $(function () {
          $('[data-toggle="tooltip"]').tooltip();
        });

        // Add class to navigation when search is open
        $('.morphsearch-form').on("click", function(){
          // $('body').addClass('overflowhide');
          $('.sliding-nav').addClass('search-open');
        });
        $('.morphsearch-close').on("click", function(){
          $('.sliding-nav').removeClass('search-open');
          // $('body').removeClass('overflowhide');
        });

        $(document).keyup(function(e) {
            if (e.keyCode == 27) { 
                $('.sliding-nav').removeClass('search-open', 'menu-open');
                // $('body').removeClass('overflowhide');
            }
        });

        // Init FastClick to remove 300ms touch delay on mobile
        $(function() {
          FastClick.attach(document.body);
        });

        if( $('body').hasClass("rethink-beautiful") ){
          $('.subnav').affix({
            offset: {
              top: function(){ return $(window).height() - 90 }
            }
          });
        } else if($('body').hasClass('heart-and-soil')) {
          $('.subnav').affix({
            offset: {
              top: function(){ return $(window).height() - 90 }
            }
          });          
        
        }
      
        // Affix and offset subnav
        if($('body').hasClass('methodologies')) {
          $('.subnav').affix({
            offset: {
              top: $('#hero').height() - 90
            }
          });          
        
        } else {
          $('.subnav').affix({
            offset: {
              top: $('#hero').height()
            }
          });
        }
   
        // toggle nav class on innovations page after hero
        if ($('body').hasClass('innovations')) {
          $(".sliding-nav").addClass("innonav"); 
          $(window).scroll(function() {    
              var scroll = $(window).scrollTop();
                      hero = $('#start').offset().top - 80;
              if (scroll >= hero) {
                  $(".sliding-nav").removeClass("innonav");
              } else if (scroll < hero) {
                  $(".sliding-nav").addClass("innonav"); 
              }
          });
        }

        if ($('body').hasClass('methodologies')) {
          $(".sliding-nav").addClass("innonav"); 
          $(window).scroll(function() {    
              var scroll = $(window).scrollTop();
                  hero = $('#overview').offset().top - 80;
              if (scroll >= hero) {
                  $(".sliding-nav").removeClass("innonav");
              } else if (scroll < hero) {
                  $(".sliding-nav").addClass("innonav"); 
              }
          });
        }

        if ($('body').hasClass('rethink-beautiful')) {
          $(".sliding-nav").addClass("innonav"); 
          $(window).scroll(function() {    
              var scroll = $(window).scrollTop();
                  hero = $('#love-letter').offset().top - 130;
              if (scroll >= hero) {
                  $(".sliding-nav").removeClass("innonav");
              } else if (scroll < hero) {
                  $(".sliding-nav").addClass("innonav"); 
              }
          });
        }

        // Enable scrollspy on subnav
        if($('body').hasClass('rethink-beautiful')) {
          $('body').scrollspy({ 
            target: '#subnavigation',
            offset: 120
          });
        } else if($('body').hasClass('heart-and-soil')) {
          $('body').scrollspy({ 
            target: '#subnavigation',
            offset: 90
          });
        } else {
          $('body').scrollspy({ 
            target: '#subnavigation',
          });
        }

        // Add 'open' class to nav when expanded
        $('body').click(function() {
          setTimeout(function() {
            if( $('.menu-item').hasClass('open') ) {
              $('.sliding-nav').addClass('open');
            } else {
              $('.sliding-nav').removeClass('open');
            }
          }, 1);
        });

        // Add class to open menu, fade menu in/out when toggle is clicked
        $('.menu-toggle').click(function() {
          $('.sliding-nav').toggleClass('expanded');
          $('.navigation-container').fadeToggle();

          if( !$('.sliding-nav').hasClass('expanded') ) {
            $('.back-icon').fadeOut();
          }
        });

        // Open navigation drawer (submenus)
        $('.navigation-menu > .menu-item').click(function() {
          if( $(window).width() <= 992 ) {
            $('.back-icon').fadeIn();
          }
        });

        $(window).on('resize', function(){
          if( $(window).width() > 992 ) {
            $('.back-icon').fadeOut();
          } else if( $('.menu-item').hasClass('open') ) {
            $('.back-icon').fadeIn();
          }
        });

        // Close navigation drawer (submenus)
        $('.back-icon').click(function() {
          $('.menu-item').removeClass('open');
          $(this).fadeOut();
        });

        // Card flip on supplements
        $('.standards-btn').on('click', function(e) {
          $('.call-out-del.sub.back').toggleClass('visible');
          $('.standards-btn').toggleClass('back');
          e.preventDefault();
        });

        $('.family-icons .standards-btn').on('click', function(e) {
          $('.standards-btn').removeClass('back');
          e.preventDefault();
        });

        //Enable swiping
        $(".carousel-inner").swipe( {
          swipeLeft:function(event, direction, distance, duration, fingerCount) {
            $(this).parent().carousel('next'); 
          },
          swipeRight: function() {
            $(this).parent().carousel('prev'); 
          },
          //Default is 75px, set to 0 for demo so any distance triggers swipe
          threshold: 75
        });

        $(function(){
            $('input#mce-EMAIL').keydown(function(e){
                if (e.keyCode == 13) {
                    $(this).parents('form').submit();
                    e.preventDefault();
                    return false;
                }
            });
        });

        // Apply ie10 class to html tag in case of ie10
        var isIE10;
        if ("onpropertychange" in document && !!window.matchMedia) {
          isIE10 = true;
          $('html').addClass('ie10');
        }
        
        var isIE11 = !!navigator.userAgent.match(/Trident\/7\./);
        if (isIE11){
          $('html').addClass('ie11');
        }

        // Video fix for ie browsers
        setTimeout(function(){
          $( "body.about .wrap.container, body.beauty-study .wrap.container, body.supplements-and-nutrition .wrap.container, body.food-and-beverage .wrap.container" ).animate({
            opacity: 1.0
          }, 1500 );
        },2000)

        setTimeout(function(){
          $( "body.natures-rainbow .wrap.container" ).animate({
            opacity: 1.0
          }, 500 );
        }, 500)

        setTimeout(function(){
          $( "body.tinamc" ).animate({
            opacity: 1.0
          }, 500 );
        }, 500)

        setTimeout(function(){
          if($('html').hasClass('ie11') || $('html').hasClass('ie9') || $('html').hasClass('ie10')){
            $('.chapter-guide').css('top', ($(window).height()/2) - 7);
            $('.timeline').css('top', ($(window).height()/2));
            $('#section-0 .fp-tableCell').children().first().css('height', $(window).height());
            $(window).resize(function(){
              $('#section-0 .fp-tableCell').children().first().css('height', $(window).height());
              $('.chapter-guide').css('top', ($(window).height()/2) - 7);
              $('.timeline').css('top', ($(window).height()/2));
            });
          }
        },2000)

      },
      finalize: function() {

        // JavaScript to be fired, after the init JS
        jQuery('.menu-toggle').click(function() {
          $('#mp-menu').toggleClass('open');
          $('.sliding-nav').toggleClass('menu-open');
          $('#mp-menu > .mp-level').toggleClass('mp-level-open');
          $('.mp-level.products').removeClass('open');
          $('.mp-back').removeClass('visible');
          $('.sliding-nav').removeClass('sub-menu-open');
        });

        // Open second level procuts menu
        $('.product-menu').click(function() {
          $('.mp-level.products').addClass('open');
          $('.sliding-nav').addClass('sub-menu-open');
          $('.mp-back').addClass('visible');
        });

        // Close second level procuts menu
        $('.mp-back').click(function() {
          $('.mp-level.products').removeClass('open');
          $(this).removeClass('visible');
          $('.sliding-nav').removeClass('sub-menu-open');
        });

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // Beauty Study page.
    'beauty_study': {
      init: function() {
        // JavaScript to be fired on the beauty study page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


})(jQuery); // Fully reference jQuery after this point.



// OUR TEAM GAME

$(document).ready(function() {


  function isMobile() {    
      var agent   = navigator.userAgent;
    if ( agent.match(/(iPhone|iPod|iPad|Blackberry|Android)/) ) {
          return true;
      }
  }

  setTimeout( function() {

    if (!isMobile()){
      $('.scroll-button-team').show().animate({ opacity: "1" }, 500).click(function() {
        $('html, body').animate({scrollTop: $('#intro').offset().top }, 700);
      });
    }
  }, 1000);

  // Start game

  var questionsAnswered = 0;
  var questionsRight = 0;
  var delay = 250;
  var currentLevel = $('.game-state[name="0"]');

  function startGame() {
    questionsAnswered = 0;
    questionsRight = 0;
    $('.progress-bar-segment').removeClass('completed');
    $('.progress, .next-level-wrap, .scoring').hide();
    $('.game-state[name="16"]').hide();
    currentLevel.animate({ top: "24px", opacity: "0" }, delay, function() { 
      $(this).hide();
      $('.game-state[name="1"], #answer-buttons').show().animate({ top: "0", opacity: "1" }, delay);
      currentLevel = $('.game-state[name="1"]');
    }); 
  }

  $('.start .button, .reset-button').click( startGame );

  function scoreAnswer() {
    var answer = $(this).attr('name');
    var correct = false;
    var correctDetail;
    var level = $('.game-state');
    questionsAnswered++;

    if ( answer == "true") {

      if ( currentLevel.attr('name') == 1
       || currentLevel.attr('name') == 3
       || currentLevel.attr('name') == 4
       || currentLevel.attr('name') == 6
       || currentLevel.attr('name') == 9
       ||currentLevel.attr('name') == 10
       || currentLevel.attr('name') == 11
       || currentLevel.attr('name') == 13
       || currentLevel.attr('name') == 15 ) {
        correct = true;
        correctDetail = "true-correct";
        questionsRight++;
      } else {
        correct = false;
        correctDetail = "true-incorrect";
      }

    } else if ( answer == "false" ) {
      
      if ( currentLevel.attr('name') == 2
       || currentLevel.attr('name') == 5
       || currentLevel.attr('name') == 7
       || currentLevel.attr('name') == 8
       || currentLevel.attr('name') == 12
       || currentLevel.attr('name') == 14 ) {
        correct = true;
        correctDetail = "false-correct";
        questionsRight++;
      } else {
        correct = false;
        correctDetail = "false-incorrect";
      }

    }

    // Show answer

    $('#answer-buttons').animate({ top: "24px", opacity: "0" }, delay);
    currentLevel.find('.question').animate({ top: "24px", opacity: "0" }, delay);
    $('.progress-bar-segment[name="' + questionsAnswered + '"]').addClass('completed');
    setTimeout( function() {
      $('#answer-buttons').hide();
      currentLevel.find('.question').hide();
      $('.scoring[name="' + correctDetail + '"]').show();
      $('.total-correct').html( questionsRight );
      $('.progress, .next-level-wrap').show().animate({ top: "0", opacity: "1" }, delay);
      currentLevel.find('.answer').show().animate({ top: "0", opacity: "1" }, delay);
    }, delay);
  }

  $('#answer-buttons .button').click( scoreAnswer );

  function nextLevel() {

    $('.progress, .next-level-wrap').animate({ top: "24px", opacity: "0" }, delay, function() { $(this).hide(); $('.scoring').hide(); });
    currentLevel.animate({ top: "24px", opacity: "0" }, delay, function() { 
      $(this).hide()
      $(this).find('.question').css({ opacity: "1", top: "0", display: "block" });
      $(this).find('.answer').css({ opacity: "0", top: "24px", display: "none" });
    });
    setTimeout( function() {
      if ( questionsAnswered !== 15 ) {
        $('.game-state[name="' + ( questionsAnswered + 1 ) + '"], #answer-buttons').show().animate({ top: "0", opacity: "1" }, delay);
        currentLevel = $('.game-state[name="' + ( questionsAnswered + 1 ) + '"]');
      } else {
        $('.game-state[name="' + ( questionsAnswered + 1 ) + '"]').show().animate({ top: "0", opacity: "1" }, delay);
        if ( questionsRight < 5 ) {
          $('.evaluation[name="0-4"]').show().animate({ top: "0", opacity: "1" }, delay);
        } else if ( questionsRight >= 5 && questionsRight < 11 ) {
          $('.evaluation[name="5-10"]').show().animate({ top: "0", opacity: "1" }, delay);
        } else if ( questionsRight >= 11 ) {
          $('.evaluation[name="11-15"]').show().animate({ top: "0", opacity: "1" }, delay);
        }
      }
    }, delay);

  }

  $('.next-level-button').click( nextLevel );
  
});

// Image Map 

// $('area').each(function(){
//     var area = $(this),
//         alt = area.attr('alt');
//     area.mouseenter(function(){
//         $('#overlay').html(alt);
//         console.log("mouse enter area");
//     }).mouseleave(function(){
//         $('#overlay').html('');
//         console.log("mouse leave area");
//     });
// });

/*
* rwdImageMaps jQuery plugin v1.5
*
* Allows image maps to be used in a responsive design by recalculating the area coordinates to match the actual image size on load and window.resize
*
* Copyright (c) 2013 Matt Stow
* https://github.com/stowball/jQuery-rwdImageMaps
* http://mattstow.com
* Licensed under the MIT license
*/
(function(a){a.fn.rwdImageMaps=function(){var c=this;var b=function(){c.each(function(){if(typeof(a(this).attr("usemap"))=="undefined"){return}var e=this,d=a(e);a("<img />").load(function(){var g="width",m="height",n=d.attr(g),j=d.attr(m);if(!n||!j){var o=new Image();o.src=d.attr("src");if(!n){n=o.width}if(!j){j=o.height}}var f=d.width()/100,k=d.height()/100,i=d.attr("usemap").replace("#",""),l="coords";a('map[name="'+i+'"]').find("area").each(function(){var r=a(this);if(!r.data(l)){r.data(l,r.attr(l))}var q=r.data(l).split(","),p=new Array(q.length);for(var h=0;h<p.length;++h){if(h%2===0){p[h]=parseInt(((q[h]/n)*100)*f)}else{p[h]=parseInt(((q[h]/j)*100)*k)}}r.attr(l,p.toString())})}).attr("src",d.attr("src"))})};a(window).resize(b).trigger("resize");return this}})(jQuery);


$(document).ready(function() {
  $('map').imageMapResize();
  $('img[usemap]').rwdImageMaps();

  // mouseenter/mouseleave method

  $('area').mouseenter(function() { 
    $('.extra').html( $(this).attr('alt') );

    $('.extra').addClass('show');

  });
  
  $('area').mouseleave(function() {
    $('.extra').removeClass('show'); 
    setTimeout(function() {
      $('.extra').html("");
    }, 150);
});

// hover method

//   $('area').hover(function() {
  //     console.log("hovered over area");
      
  //     $('.extra').html( $(this).attr('alt') );
  //     $('.extra').addClass('show');
  //   }, function(){
  //      $('.extra').removeClass('show'); 
  //         setTimeout(function() {
  //      $('.extra').html("");
  //  }, 150);
  //   },
  //   );
    
  
    $('area').on('click', function(e) {
      console.log("area clicked");
      e.preventDefault();
      var target = $(this).attr('href');
      var imagemapItems = $('.imagemap__item');

      imagemapItems.hide();
      $(target).show();
      $(target+'> h4').addClass('is-open');
    });

    $('#testimonial_popup').on('click', function(e) {
      console.log("#testimonial_popup");
      e.preventDefault();

      $('.video_popup').addClass('show');

      var iframe = $('iframe');

      if ( iframe ) {
        var player = new Vimeo.Player(iframe);
        player.play();
      }
    });

    $('#close_video_popup').on('click', function(e) {
      console.log("#close_video_popup");
      e.preventDefault();

      var iframe = $('iframe');

      if ( iframe ) {
        var player = new Vimeo.Player(iframe);
        player.pause();
      }

      $('.video_popup').removeClass('show');
    })
});

//appends an "active" class to .popup and .popup-content when the "Open" button is clicked
$(".pop-up-open").on("click", function() {
  $(".popup-overlay, .popup-content").addClass("active");
});

//removes the "active" class to .popup and .popup-content when the "Close" button is clicked 
$(".close, .popup-overlay").on("click", function() {
  $(".popup-overlay, .popup-content").removeClass("active");
});
